import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { toBackendLocale } from '../../../../helpers/class/RequestLocale';
import { useT, guestsToken, useLocale, intlLocale } from '../../../../helpers/i18n';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { faSearch, faSpinner, faBuildings } from '@fortawesome/pro-regular-svg-icons'
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import {
  faCalendar as farCalendar,
  faMapMarkerAlt as farMapMarkerAlt,
  faUserFriends as farUserFriends,
  faBed as farBed,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dialog from '@mui/material/Dialog';
import Popover from '@mui/material/Popover';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import axios from 'axios';

import { getSearchDefaultOptionsAction, loadSearchOptionsAction, getPropertiesFiltersPropertyTypes } from '../../../../api/client';
import { redirectToWebHotelier } from '../../../../helpers/BookingHelper';
import Checkers from '../../../../helpers/class/Checkers';
import {
  fetchPropertiesAction, fetchPropertiesFiltersPropertyTypesAction, removeAllDestination, setAdults,
  setApplyParams, setBedrooms, setDateRange, setDestination, setGtypes, setInfants, setKids,
  setLoadingProperties,
  setOffset, setPageNumber, setSearchSpinner, setSearchText
} from '../../../../redux/actions';
import * as appContext from '../../../AppContext';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { DesktopDateRangePicker } from '@mui/x-date-pickers-pro/DesktopDateRangePicker';
import { MobileDateRangePicker } from '@mui/x-date-pickers-pro/MobileDateRangePicker';
import TextField from '@mui/material/TextField';
import Guests from './partials/Guests';
import { useRouter } from "next/router";
import { fetchBuilderSettingByKey, customBuilderLabel, SEARCH_BUTTON_DEFAULT_LABELS, SELECT_LABEL_DEFAULT_LABELS } from "../../../../helpers/MethodHelper";
import { getDefaultOptions } from "./FullWidthBar";
import { DateRange } from "@mui/lab/DateRangePicker";
import dayjs from "dayjs";
import AsyncCreatableSelect from 'react-select/async-creatable';
import Select from 'react-select';
import { minHeight } from '@mui/system';
import DateRangeWrapper from '../../property/partials/bookings/DateRangeWrapper';

export default function FlexibleSearchBar(props) {
  const dateLocale = useLocale();
  const t = useT();

  const updateUri = props.hasOwnProperty('updateUri') ? props.updateUri : true

  const dispatch = useDispatch()

  const router = useRouter()

  const { textColor, borderColor, searchbarBgColor, designMode, isSearchBarSticky, searchbarThemeColor } = props

  //  const inputColor = textColor !== 'text-black' ? 'white' : 'black';
  // const labelColor = textColor !== 'text-black' ? 'white' : 'black';

  const inputColor = textColor !== 'text-black' ? 'white' : '#000'
  const labelColor = textColor !== 'text-black' ? 'white' : '#000';
  const placeholderColor = inputColor;
  const dividerColor = textColor !== 'text-black' ? 'white' : 'black';

  const currentDestination = useSelector(state => state['appSettings']['currentDestination'])

  const isHotel = useSelector(state => state['appSettings']['isHotel'])

  const isChain = useSelector(state => Checkers.valueToBoolean(state['appSettings']['isChain']))

  const propertiesParams = useSelector(state => state['propertiesParams']);

  const customSearch = useSelector(state => state['propertiesParams']['search']);

  const pageId = useSelector(state => state['propertiesParams']['page_id']);

  const destinations = useSelector(state => state['propertiesParams']['destinations']);

  const isListingPage = useSelector(state => state['propertiesParams']['isListingPage']);

  const isSearchPage = useSelector(state => state['propertiesParams']['isSearchPage']);

  const isDestinationPage = useSelector(state => state['propertiesParams']['isDestinationPage']);

  const [selectedLocation, setSelectedLocation] = useState(null);

  const bookingBarRef = useRef<HTMLDivElement>(null);

  const [bookingBarDiv, setBookingBarDiv] = useState(null);

  const [isBarSticky, setIsBarSticky] = useState(false);
  const [isCssStuck, setIsCssStuck] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [barHeight, setBarHeight] = useState(0);
  const sentinelRef = useRef<HTMLDivElement>(null);
  const portalRef = useRef<HTMLDivElement | null>(null);
  const popoverRef = useRef(props.popover);
  useEffect(() => { popoverRef.current = props.popover; });


  const designColor = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'designColor')
  );

  const searchbarBgColorFromRedux = useSelector(
    state => state['builderSettingsData']['settings']?.searchbarBgColor || null
  );

  const activeSearchbarColor = searchbarBgColor || searchbarBgColorFromRedux || null;

  const searchBtnLabel = customBuilderLabel(useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_search_btn_label')
  ), SEARCH_BUTTON_DEFAULT_LABELS);

  const searchSpinner = useSelector(state => state['appSettings']['searchSpinner']);

  const searchSelectLabel = customBuilderLabel(useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_properties_select_label')
  ), SELECT_LABEL_DEFAULT_LABELS);

  const bookingSearchbarWithBedroomsSetting = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'bookingSearchbarWithBedrooms')
  );
  const bookingSearchbarWithBedrooms = bookingSearchbarWithBedroomsSetting && !isHotel;

  const showHotelBedrooms = isHotel;

  const managerInfo = props.managerInfo;
  const showManagerSafeNote = (!props.isManager || isChain) && managerInfo != null && managerInfo.showInSearchbar
    && ( Checkers.isValidString(managerInfo.title) || Checkers.isValidString(managerInfo.logo) );
  // On a dark search bar (white text) use the manager's dark-background logo, otherwise the light-background one.
  const managerLogo = inputColor === 'white'
    ? ( Checkers.isValidString(managerInfo?.logoDark) ? managerInfo.logoDark : managerInfo?.logo )
    : ( Checkers.isValidString(managerInfo?.logoLight) ? managerInfo.logoLight : managerInfo?.logo );
  const managerSafeNote = showManagerSafeNote ? (
    <div style={{ fontSize: props.showOnMobile ? '12px' : '13px', lineHeight: 1.35, color: inputColor, opacity: 0.85, display: props.showOnMobile ? 'block' : 'flex', alignItems: 'center', gap: props.showOnMobile ? 0 : '8px', whiteSpace: props.showOnMobile ? 'normal' : 'nowrap' }}>
      {Checkers.isValidString(managerLogo) && (
        <>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={managerLogo} alt={managerInfo.title} style={{ height: props.showOnMobile ? 16 : 20, width: 'auto', display: 'block', marginBottom: props.showOnMobile ? 4 : 0, flex: '0 0 auto' }} />
        </>
      )}
      <span>{t('search.managerSafeNote')}&nbsp;<strong>{managerInfo.title}</strong></span>
    </div>
  ) : null;

  const [removeAllDestinations, setRemoveAllDestinations] = useState(false)

  const [localSearchText, setLocalSearchText] = useState(null)

  const [localDestinationId, setLocalDestinationId] = useState(null)

  const checkin = useSelector(state => state['propertiesParams']['checkin'])

  const checkout = useSelector(state => state['propertiesParams']['checkout'])

  const [localDateRange, setLocalDateRange] = useState<DateRange<Date>>([null, null]);

  const bedrooms = useSelector(state => state['propertiesParams']['bedrooms']);

  const [localBedrooms, setLocalBedrooms] = useState(bedrooms)

  const [localAdultsNum, setLocalAdultsNum] = useState(0)

  const [localKidsNum, setLocalKidsNum] = useState(0)

  const [localInfantsNum, setLocalInfantsNum] = useState(0)

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)

  const [mobileDrawerTab, setMobileDrawerTab] = useState<'destination' | 'dates'>('destination')
  const [mobileGuestsText, setMobileGuestsText] = useState('')
  const [mobileDialogOpen, setMobileDialogOpen] = useState(false)
  const [mobileSummaryOpen, setMobileSummaryOpen] = useState(false)
  const [mobileSubDrawer, setMobileSubDrawer] = useState<'guests' | 'propertyType' | 'bedrooms' | null>(null)
  const mobileFromSummary = useRef(false)
  const locationSetByUser = useRef(false)
  const mobileDrawerOpenRef = useRef(false)
  const mobileSubDrawerRef = useRef<'guests' | 'propertyType' | 'bedrooms' | null>(null)

  useEffect(() => { mobileSubDrawerRef.current = mobileSubDrawer; }, [mobileSubDrawer])

  useEffect(() => { mobileDrawerOpenRef.current = mobileDrawerOpen; }, [mobileDrawerOpen])



  useEffect(() => {
    setLocalAdultsNum(propertiesParams.adults)
    setLocalKidsNum(propertiesParams.kids)
    setLocalInfantsNum(propertiesParams.infants)
  }, [propertiesParams]);

  useEffect(() => {
    let checkin_unix = new Date(checkin).valueOf() ? new Date(checkin) : null
    let checkout_unix = new Date(checkout).valueOf() ? new Date(checkout) : null

    setLocalDateRange([checkin_unix, checkout_unix])
  }, [checkin, checkout, propertiesParams])

  useEffect(() => {
    setLocalBedrooms(bedrooms)
  }, [bedrooms, propertiesParams])

  const dateRangeHandler = (val: DateRange<Date>) => {
    if (props.calendar && typeof props.calendar.setValue === 'function') {
      props.calendar.setValue(val);
    }
    if (props.calendar && typeof props.calendar.focusToggle === 'function') {
      props.calendar.focusToggle('close_checkin');
    }
    setLocalDateRange(val)
  }

  const clearLocation = () => {
    setSelectedLocation(null);
    setRemoveAllDestinations(true);
    setLocalSearchText(null);
    setLocalDestinationId(null);
    setLocalAdultsNum(0);
    setLocalKidsNum(0);
    setLocalInfantsNum(0);
    setLocalBedrooms(null);
    setSelectedPropertyTypes([]);
  };

  const handleInputChange = (input) => {
    locationSetByUser.current = true;
    let location_val = input.value;
    let location_data = location_val.split("_");
    let location_type = location_data[0];
    let location_id = location_data[1];

    if (location_type == 'all') {
      setSelectedLocation(input);
      setRemoveAllDestinations(true)
      setLocalSearchText('')
    } else if (location_type == 'destination') {
      setSelectedLocation(input);
      setRemoveAllDestinations(false)
      setLocalDestinationId(location_id)
      setLocalSearchText('')
    } else if (location_type != 'property') {
      setSelectedLocation(input);
      setRemoveAllDestinations(true)
      setLocalSearchText(input.label)
    } else {
      let customOption = {
        value: input.label,
        label: input.label
      }

      setSelectedLocation(customOption)
      setRemoveAllDestinations(true)
      setLocalSearchText(input.label)
    }
  };

  const dispatchValues = async () => {
    if (removeAllDestinations) {
      dispatch(removeAllDestination())
    } else if (localDestinationId != null) {
      dispatch(setDestination(localDestinationId))
    }

    dispatch(setSearchText(localSearchText))

    dispatch(setDateRange(localDateRange))

    dispatch(setBedrooms(localBedrooms))

    dispatch(setAdults(localAdultsNum))

    dispatch(setKids(localKidsNum))

    dispatch(setInfants(localInfantsNum))

    return true
  }

  const searchHandler = async (event) => {
    event.preventDefault()

    if (!Checkers.valueToBoolean(props.isManager) && (Checkers.isValidString(props.propertyBookingTypeValue) || Checkers.isValidString(props.webHotelierBookUrl) || Checkers.isValidString(props.bookingTypeValue))) {
      const checkin = localDateRange[0] != null ? dayjs(localDateRange[0]).format('YYYY-MM-DD') : null;
      const checkout = localDateRange[1] != null ? dayjs(localDateRange[1]).format('YYYY-MM-DD') : null;

      const redirected = redirectToWebHotelier(
        props.propertyBookingTypeValue,
        props.webHotelierBookUrl,
        props.bookingTypeValue,
        props.webHotelierRoomCodes,
        checkin,
        checkout,
        localAdultsNum,
        localKidsNum,
        localInfantsNum,
        localBedrooms
      );

      if (redirected) {
        event.preventDefault();
        return;
      }
    }

    await dispatchValues()

    dispatch(setOffset(0))
    dispatch(setPageNumber(1))
    dispatch(setGtypes(selectedPropertyTypes))

    const searchParams = {
      ...propertiesParams,
      offset: 0,
      adults: localAdultsNum,
      kids: localKidsNum,
      infants: localInfantsNum,
      bedrooms: localBedrooms,
      search: localSearchText,
      gtypes: selectedPropertyTypes,
      selected_location: selectedLocation ? selectedLocation.value : null,
      destinations: removeAllDestinations ? [] : (localDestinationId != null ? [localDestinationId] : propertiesParams.destinations),
      checkin: localDateRange[0] != null ? dayjs(localDateRange[0]).format('YYYY-MM-DD') : null,
      checkout: localDateRange[1] != null ? dayjs(localDateRange[1]).format('YYYY-MM-DD') : null,
    };
    // keep propertiesParams in sync for fetchPropertiesAction calls below
    Object.assign(propertiesParams, searchParams);

    if (selectedLocation == null && !isSearchPage) {
      let queryString = Checkers.serialize(searchParams);
      router.push("/properties/search/?" + queryString);
      event.preventDefault()
      return;
    }

    let location_id = ''
    let location_val = ''
    if (selectedLocation != null) {
      location_val = selectedLocation.value;
      let location_data = location_val.split("_");
      let location_type = location_data[0];
      location_id = location_data[1];
    }

    dispatch(setSearchSpinner(true))

    if (isListingPage && currentDestination == propertiesParams.destinations[0] && Checkers.isValidPositiveNumber(location_id)) {
      dispatch(setLoadingProperties(true));
      dispatch<any>(fetchPropertiesAction(propertiesParams))
      dispatch(setApplyParams(1))

      let queryString = Checkers.serialize(searchParams);
      const newUrl = "/properties/search/?" + queryString
      if (updateUri) {
        window.history.replaceState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl)
      }
    } else if (isSearchPage) {
      dispatch(setLoadingProperties(true));
      dispatch<any>(fetchPropertiesAction(searchParams))
      dispatch(setApplyParams(1))

      let queryString = Checkers.serialize(searchParams);
      const newUrl = "/properties/search/?" + queryString
      if (updateUri) {
        window.history.replaceState({ ...window.history.state, as: newUrl, url: newUrl }, '', newUrl)
      }
    } else {
      let queryString = Checkers.serialize(searchParams);
      router.push("/properties/search/?" + queryString);
    }
    event.preventDefault()
  };

  useEffect(() => {
    if (props.popover && typeof props.popover.guestsSetText === 'function') {
      props.popover.guestsSetText(guestsToken(['adults', localAdultsNum + localKidsNum], ['infants', localInfantsNum]));
    }
  }, [localAdultsNum, localKidsNum, localInfantsNum])

  const loadOptions = (inputValue, callback) => {
    loadSearchOptionsAction(pageId, inputValue, callback)
  }

  const allPropertyTypes = useSelector(state => state['propertiesFiltersData']?.propertyTypes || []);
  const [locationPropertyTypes, setLocationPropertyTypes] = useState<{ id: number, type: string }[]>([]);
  const [locationPropertyTypesFiltered, setLocationPropertyTypesFiltered] = useState(false);
  const selectedLocationType = selectedLocation ? String(selectedLocation.value).split('_')[0] : null;
  const isSpecificLocationSelected = selectedLocationType === 'destination' || selectedLocationType === 'location';

  const propertyTypes = isSpecificLocationSelected
    ? (locationPropertyTypesFiltered ? locationPropertyTypes : [])
    : allPropertyTypes;
  const reduxGtypes = useSelector(state => state['propertiesParams']['gtypes'] || []);
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState<number[]>(() => (reduxGtypes || []).map(Number));
  const [ptAnchorEl, setPtAnchorEl] = useState<HTMLElement | null>(null);
  const [bedroomsAnchorEl, setBedroomsAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setSelectedPropertyTypes((reduxGtypes || []).map(Number));
  }, [JSON.stringify(reduxGtypes)]);

  useEffect(() => {
    if (isSpecificLocationSelected && !locationPropertyTypesFiltered) return;

    if (propertyTypes.length > 0 && (reduxGtypes || []).length === 0) {
      const allIds = propertyTypes.map((pt: { id: number, type: string }) => pt.id);
      setSelectedPropertyTypes(allIds);
      dispatch(setGtypes(allIds));
    }
  }, [JSON.stringify(propertyTypes), isSpecificLocationSelected, locationPropertyTypesFiltered]);

  useEffect(() => {
    if (!pageId) return;
    dispatch<any>(fetchPropertiesFiltersPropertyTypesAction({ page_id: pageId, locale: toBackendLocale(router.locale || 'en') }));
  }, [pageId]);

  useEffect(() => {
    if (!selectedLocation || !pageId) {
      setLocationPropertyTypes([]);
      setLocationPropertyTypesFiltered(false);
      return;
    }
    const location_val = String(selectedLocation.value);
    const [location_type, location_id] = location_val.split('_');
    const params: any = { page_id: pageId, locale: toBackendLocale(router.locale || 'en') };
    if (location_type === 'destination' && location_id) params.destinations = [location_id];
    else if (location_type === 'location' && location_id) params.locations = [location_id];
    else {
      setLocationPropertyTypes([]);
      setLocationPropertyTypesFiltered(false);
      return;
    }
    getPropertiesFiltersPropertyTypes(params).then((res: any) => {
      const types = res?.property_types || [];
      setLocationPropertyTypes(types);
      setLocationPropertyTypesFiltered(true);
    });
  }, [selectedLocation, pageId]);

  const [defaults, setDefaults] = useState(null);
  useEffect(() => {
    getDefaultOptions(pageId)
      .then(response => {

        setDefaults(response.options);
        let destination = Checkers.isValidArray(destinations) ? destinations[0] : null

        const selectedLocationParam = typeof window !== 'undefined'
          ? new URLSearchParams(window.location.search).get('selected_location')
          : null;

        let destinationFlag = false
        Checkers.isValidArray(response.options) && response.options.map((item) => {
          if (item.value == 'destination_' + destination) {
            setSelectedLocation(item)
            destinationFlag = true
          }
          if (!destinationFlag && selectedLocationParam && item.value == selectedLocationParam) {
            setSelectedLocation(item)
            destinationFlag = true
            if (String(selectedLocationParam).startsWith('all')) setRemoveAllDestinations(true)
          }
        })

        if (Checkers.isValidString(customSearch) && !destinationFlag) {
          let customOption = {
            value: customSearch,
            label: customSearch
          }
          setSelectedLocation(customOption)
        } else if (!destinationFlag) {
          if ((isListingPage || isSearchPage) && Checkers.isValidArray(response.options) && response.options.length > 0) {
            const allPropertiesOption = response.options.find((item) => String(item.value).includes('all_properties'))
            const defaultOption = allPropertiesOption || response.options[response.options.length - 1]
            setSelectedLocation(defaultOption)
            const locData = String(defaultOption.value).split('_')
            if (locData[0] === 'destination') {
              setLocalDestinationId(locData[1])
            } else if (locData[0] !== 'all' && locData[0] !== 'property') {
              setRemoveAllDestinations(true)
              setLocalSearchText(defaultOption.label)
            } else {
              setRemoveAllDestinations(true)
            }
          } else {
            setSelectedLocation(null)
            setRemoveAllDestinations(true)
          }
        }
      });
  }, [destinations]);

  let searchbarRadius = '10px';
  if (props.searchbarRadius != null) {
    searchbarRadius = props.searchbarRadius + 'px'
  } 

  // Create a portal container at document.body level so the sticky bar escapes any parent stacking context
  useEffect(() => {
    const el = document.createElement('div');
    document.body.appendChild(el);
    portalRef.current = el;
    return () => { document.body.removeChild(el); };
  }, []);

  // Track header height via ResizeObserver
  useEffect(() => {
    const header = document.querySelector('.Header') as HTMLElement | null;
    if (!header) return;
    const measure = () => setHeaderHeight(header.offsetHeight);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(header);
    return () => ro.disconnect();
  }, []);

  // Scroll handler — capture bar height synchronously at the moment of transition
  // so the spacer always matches exactly, avoiding the jump when the secondary row is visible
  useEffect(() => {
    if (props.disableInternalSticky) return;

    const STICKY_OFFSET = 80;
    const HYSTERESIS = 20; // prevents flickering

    const handleScroll = () => {
      if (mobileDrawerOpenRef.current || mobileSubDrawerRef.current) return;

      if (popoverRef.current?.open) popoverRef.current.handleClose();

      if (props.calendar && typeof props.calendar.focusToggle === 'function') {
        props.calendar.focusToggle('close_all');
      }

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      if (!sentinelRef.current) return;

      const top = sentinelRef.current.getBoundingClientRect().top;

      setIsBarSticky(prev => {
        const shouldBeSticky = prev
          ? top < headerHeight - STICKY_OFFSET + HYSTERESIS
          : top < headerHeight - STICKY_OFFSET;

        if (shouldBeSticky && !prev && bookingBarRef.current) {
          setBarHeight(bookingBarRef.current.offsetHeight);
        }

        return shouldBeSticky;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headerHeight, props.disableInternalSticky]);

  useEffect(() => {
    if (!props.disableInternalSticky) return;
    const el = document.getElementById('search_bar');
    if (!el) return;
    const onScroll = () => setIsCssStuck(el.getBoundingClientRect().top <= 0);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [props.disableInternalSticky]);

  useEffect(() => {
    const onScroll = () => setPtAnchorEl(null);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const setNextElementPaddingTop = (nextElem, _nextElemPaddingTop?: string, _bookingBarHeight?: number) => {
    // const paddingTop = parseInt(String(bookingBarHeight)) / 2 + parseInt(nextElemPaddingTop);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // nextElem.style.setProperty( 'padding-top', `${paddingTop}px`, 'important' );
  };

  useEffect(() => {
    if (window !== undefined) {
      let bookingBarHeight = 0;
      setBookingBarDiv(bookingBarRef?.current)
      if (bookingBarDiv) {
        bookingBarHeight = bookingBarDiv?.getBoundingClientRect().height;
        let nextElem = bookingBarDiv.offsetParent?.offsetParent?.nextSibling;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        while (nextElem && nextElem.style === undefined) {
          nextElem = nextElem.nextSibling;
        }
        if (!nextElem) return;

        const nextElemPaddingTop = window.getComputedStyle(nextElem as Element, null).getPropertyValue('padding-top').split('px')[0];
        setNextElementPaddingTop(nextElem, nextElemPaddingTop, bookingBarHeight);
        window.addEventListener('resize', function () {
          bookingBarHeight = bookingBarDiv?.getBoundingClientRect().height;
          setNextElementPaddingTop(nextElem, nextElemPaddingTop, bookingBarHeight);
        });
      }
    }
  }, [bookingBarDiv]);

  // Compute night count and formatted date range label
  const nightCount = (() => {
    if (localDateRange[0] && localDateRange[1]) {
      const diff = Math.round((localDateRange[1].getTime() - localDateRange[0].getTime()) / 86400000);
      return diff > 0 ? diff : null;
    }
    return null;
  })();

  const formatDate = (d: Date | null) => d ? d.toLocaleDateString(intlLocale(dateLocale), { weekday: 'short', month: 'short', day: 'numeric' }) : null;

  const dateRangeLabel = (() => {
    const cin = formatDate(localDateRange[0]);
    const cout = formatDate(localDateRange[1]);
    if (cin && cout) return `${cin} – ${cout}`;
    if (cin) return cin;
    return null;
  })();

  const cardRestShadow = (textColor !== 'text-black' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.07)') + ' 0px 0.125rem 0.625rem';

  const cardStyle: React.CSSProperties = {
    borderRadius: searchbarRadius,
    boxShadow: props.searchbarShadow != null && isBarSticky ? `0px 0px ${props.searchbarShadow}px #CCC` : '',
    overflow: 'visible',
    position: 'relative',
    zIndex: 10,
  };


  const labelStyle: React.CSSProperties = {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.09em',
    textTransform: 'uppercase',
    color: labelColor,
    opacity: 0.8,
    marginBottom: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    lineHeight: 1,
  };

  const valueStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 500,
    color: inputColor,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 'normal',
  };

  const btnBgColor = activeSearchbarColor || designColor || null;
  // No explicit searchbar color: match the header's Personal color (designColor), same as the
  // header itself; findButtonCss below always forces explicit black/white contrast on the button
  // independently, so matching the card to designColor here no longer blends the button into it.
  const cardBgColor = activeSearchbarColor || designColor || ( textColor !== 'text-black' ? '#000' : null );
  const iconColor = labelColor;
  // No explicit searchbar mode selected: follow the same Dark/Light mode as the header (designMode).
  const isSearchbarThemeLight = searchbarThemeColor != null
    ? searchbarThemeColor == 0
    : Checkers.valueToBoolean( designMode );
  const findButtonCss = (isSearchPage || isDestinationPage)
    ? isSearchbarThemeLight
      ? 'bg-transparent text-white border b-transparent-white '
      : 'bg-transparent text-black border b-transparent-black '
    : isSearchbarThemeLight
      ? 'text-black bg-white'
      : 'text-white bg-black';

  const btnStyle: React.CSSProperties = btnBgColor
    ? { backgroundColor: btnBgColor, border: `1px solid ${textColor}`, color: designMode ? 'white' : '#000' }
    : {};


  const asyncSelectStyles = {
    control: () => ({ border: 'none', boxShadow: 'none', backgroundColor: 'transparent', display: 'flex', minHeight: 'unset', cursor: 'text' }),
    valueContainer: (p) => ({ ...p, padding: 0 }),
    input: (p) => ({ ...p, margin: 0, padding: 0, fontSize: '18px', fontWeight: 500, color: '#1a1a1a' }),
    singleValue: (p) => ({ ...p, fontSize: '18px', fontWeight: 500, color: '#1a1a1a', margin: 0 }),
    placeholder: (p) => ({ ...p, fontSize: '18px', color: '#aaa', margin: 0, fontWeight: 400 }),
    menu: (p) => ({ ...p, zIndex: 1000, borderRadius: '8px', marginTop: '8px', minWidth: '260px' }),
  };

  const searchbarContainerPaddingsHandler = () => {
    if (isSearchPage && !props.showOnMobile) {
      return `ps-0 ${!isBarSticky ? 'pb-0' : ''}`
    }
    return ''
  }

  const FindButton = () => (
    <button
      form="frm_book"
      type="submit"
      aria-label={t('search.search')}
      style={{
        flexShrink: 0,
        width: '100%',
        padding: '0 20px',
        margin: 0,
        alignSelf: 'center',
        height: '50px',
        borderRadius: searchbarRadius,
        border: 'none',
        cursor: 'pointer',
        fontSize: '15px',
        fontWeight: 700,
        letterSpacing: '0.03em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        minWidth: '120px',
        ...btnStyle,
      }}
      className={`btn ${findButtonCss} `}
    >
      {!searchSpinner ? (
        <>
          <FontAwesomeIcon icon={faSearch} />
          {isListingPage ? t('search.updateSearch') : (Checkers.isValidString(searchBtnLabel) ? searchBtnLabel : t('search.search'))}
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faSpinner} spin />
          {t('search.searching')}…
        </>
      )}
    </button>
  );
  const barDiv = (
    <div >
      <form id="frm_book" onSubmit={event => searchHandler(event)} className={`needs-validation ${isSearchPage ? 'bg-white' : ``}`} style={{ backgroundColor: isDestinationPage ? cardBgColor : '' }}>

        {/* ── Desktop ── */}
        <div ref={bookingBarRef} style={isBarSticky ? {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1030,
          paddingTop: 0,
          backgroundColor: cardBgColor || '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
          width: '100%',
          transition: 'padding-top 0.3s ease',
        } : props.flat ? { width: '100%', margin: '0 auto', transition: 'padding-top 0.3s ease', boxShadow: cardStyle.boxShadow } : props.showOnMobile ? { width: '100%', paddingTop: props.inSingleVilla === 'bottom' ? 0 : '16px' } : { width: '100%', margin: '0 auto', transition: 'padding-top 0.3s ease' }} className={props.isSearchBarSticky ? 'searchbar-bg-color' : (props.showOnMobile ? '' : '')}>

          <div className={props.containerClass ? props.containerClass + (!isBarSticky && !isSearchPage && !isDestinationPage && props.inSingleVilla !== 'bottom' ? ' pt-4' : '') + (isSearchPage ? ' searchbar-bg-color' : '') : `container bg-transparent ${isBarSticky || props.inSingleVilla === 'top' ? '' : 'pb-3'}`}>
            <div className={props.flat ? 'container' : (cardBgColor ? 'searchbar-bg-color' : 'searchbar-bg-color bg-master-lightest')} style={props.flat ? { backgroundColor: cardBgColor } : (isBarSticky ? { ...cardStyle, boxShadow: 'none', backgroundColor: cardBgColor || '#fff', borderBottom: 0 } : { ...cardStyle, boxShadow: cardRestShadow, ...(cardBgColor ? { backgroundColor: cardBgColor } : {}) })}>

              {/* Primary row */}
              <ThemeProvider theme={props.calendar?.customTheme || {}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <div className={`row g-0 align-items-stretch ${props.showOnMobile ? 'p-3' : 'p-4'} ${searchbarContainerPaddingsHandler()} m-0 w-100`}
                    style={{ borderRadius: props.flat ? 0 : searchbarRadius, boxShadow: props.flat || isBarSticky ? 'none' : cardRestShadow }}>

                    {props.isManager == true && !isHotel && (
                      <div
                        className={'col-6 col-md-4 pe-4 position-relative'}
                        onClick={props.showOnMobile ? () => {
                          setMobileDrawerTab('destination'); setMobileDrawerOpen(true);
                        } : undefined}
                        style={{
                          minWidth: 0,
                          cursor: props.showOnMobile ? 'pointer' : undefined,
                        }}
                      >
                        {/* Half-height divider */}
                        <div
                          style={{
                            position: 'absolute',
                            top: '0',
                            right: 0,
                            width: '1px',
                            height: '100%',
                            opacity: 0.4,
                            border: `1px dashed ${dividerColor}`,
                          }}
                        />
                        <>
                          <div style={{ ...labelStyle, ...(props.showOnMobile ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', flexWrap: 'nowrap' } : {}) }}>
                            <FontAwesomeIcon icon={farMapMarkerAlt} style={{ color: iconColor, flexShrink: 0 }} />
                            <span style={props.showOnMobile ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } : {}}>
                              {Checkers.isValidString(searchSelectLabel) ? searchSelectLabel : t('search.locationProperty')}
                            </span>
                          </div>
                          {props.showOnMobile ? (
                            <div style={{ fontSize: '14px', color: placeholderColor, opacity: selectedLocation ? 1 : 0.5, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {selectedLocation ? selectedLocation.label : t('search.whereNext')}
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                              <AsyncCreatableSelect
                                cacheOptions={false}
                                defaultOptions={defaults}
                                loadOptions={loadOptions}
                                onChange={handleInputChange}
                                closeMenuOnScroll
                                value={selectedLocation}
                                className="SearchBar-Form__form-group-select pt-0 flex-grow-1"
                                id="location_property"
                                name="location_property"
                                inputId="location_property"
                                instanceId="location_property"
                                isSearchable
                                options={props.options}
                                styles={{
                                  ...props.customStyles,
                                  valueContainer: (p) => ({ ...((props.customStyles?.valueContainer?.(p, {} as any)) || p), padding: 0 }),
                                  placeholder: (p) => ({ ...((props.customStyles?.placeholder?.(p, {} as any)) || p), fontSize: '22px', fontWeight: 500, margin: 0, color: placeholderColor, opacity: 0.5 }),
                                  input: (p) => ({ ...((props.customStyles?.input?.(p, {} as any)) || p), fontSize: '22px', fontWeight: 500, margin: 0, padding: 0, color: inputColor }),
                                  singleValue: (p) => ({ ...((props.customStyles?.singleValue?.(p, {} as any)) || p), fontSize: '22px', fontWeight: 500, margin: 0, color: inputColor }),
                                  menuPortal: (p) => ({ ...p, zIndex: 1100 }),
                                }}
                                placeholder={t('search.whereCanWeTakeYou')}
                                blurInputOnSelect
                                menuPlacement={'bottom'}
                                menuPosition="fixed"
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                formatCreateLabel={(inputValue: string) => {
                                  return t('search.searchFor', { value: inputValue })
                                }}
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                              />
                              {selectedLocation && (
                                <button
                                  type="button"
                                  onClick={(e) => { e.stopPropagation(); clearLocation(); }}
                                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1, display: 'flex', alignItems: 'center', flexShrink: 0 }}
                                  aria-label={t('search.clearDestination')}
                                >
                                  <FontAwesomeIcon icon={faCircleXmark} style={{ color: labelColor, fontSize: '16px' }} />
                                </button>
                              )}
                            </div>
                          )}
                        </>
                      </div>
                    )}

                    {/* Combined date range */}
                    <div className={'col-6 col-md-4 ps-4 pe-4 position-relative'} >
                      {(!props.isManager || isHotel) && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '0',
                            right: 0,
                            width: '1px',
                            height: '100%',
                            opacity: 0.4,
                            border: `1px dashed ${dividerColor}`,
                          }}
                        />
                      )}

                      {props.showOnMobile ? (
                        <div
                          style={{ cursor: 'pointer', height: '100%', width: '100%' }}
                          onClick={() => {
                            setMobileDrawerTab('dates'); setMobileDrawerOpen(true);
                          }}
                        >
                          <div style={labelStyle}>
                            <FontAwesomeIcon icon={farCalendar} style={{ color: iconColor }} />
                            {nightCount ? t.plural('search.nights', nightCount) : t('search.dates')}
                          </div>
                          <div style={{ fontSize: '14px', color: placeholderColor, opacity: dateRangeLabel ? 1 : 0.5, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {dateRangeLabel || t('search.addDates')}
                          </div>
                        </div>
                      ) : (
                        <DesktopDateRangePicker
                          value={localDateRange}
                          onChange={dateRangeHandler}
                          minDate={new Date()}
                          inputFormat="dd/MM/yyyy"
                          showDaysOutsideCurrentMonth={true}
                          shouldDisableDate={props.calendar?.disableAllDatesAfterTwoYears}
                          onClose={() => props.calendar?.focusToggle('close_all')}
                          renderInput={(startProps, endProps) => (
                            <div style={{ minWidth: 0, position: 'relative', cursor: 'pointer', height: '100%', width: '100%' }}>
                              <div style={labelStyle}>
                                <FontAwesomeIcon icon={farCalendar} style={{ color: iconColor }} />
                                {nightCount ? t.plural('search.nights', nightCount) : t('search.dates')}
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <div style={{ ...valueStyle, fontSize: '22px', flex: 1, color: placeholderColor, opacity: dateRangeLabel ? 1 : 0.5, fontWeight: 500 }}>
                                  {dateRangeLabel || t('search.addDates')}
                                </div>
                                {(localDateRange[0] || localDateRange[1]) && (
                                  <button
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); setLocalDateRange([null, null]); props.calendar?.setValue([null, null]); }}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 2px', lineHeight: 1, display: 'flex', alignItems: 'center', flexShrink: 0, zIndex: 1, position: 'relative' }}
                                    aria-label={t('search.clearDates')}
                                  >
                                    <FontAwesomeIcon icon={faCircleXmark} style={{ color: labelColor, fontSize: '16px' }} />
                                  </button>
                                )}
                              </div>
                              <input
                                {...startProps.inputProps}
                                ref={startProps.inputRef as React.Ref<HTMLInputElement>}
                                style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', width: '100%', height: '100%' }}
                                readOnly
                              />
                              <input {...endProps.inputProps} ref={endProps.inputRef as React.Ref<HTMLInputElement>} style={{ display: 'none' }} readOnly />
                            </div>
                          )}
                        />
                      )}
                    </div>

                    {/* Guests */}
                    {(!props.isManager || isHotel) && (props.showOnMobile || props.hasOwnProperty('popover')) ? (
                      <div className={'col-6 col-md-4 ps-4'}>
                        <button
                          type="button"
                          id="guests_label"
                          onClick={props.showOnMobile ? () => {
                            const hasGuestsSelected = bookingSearchbarWithBedrooms ? localBedrooms > 0 : (localAdultsNum > 0 || localKidsNum > 0 || localInfantsNum > 0);
                            if (hasGuestsSelected) { setMobileSummaryOpen(true); }
                            else { setMobileSubDrawer('guests'); }
                          } : props.popover.handleOpen}
                          aria-describedby={props.showOnMobile ? undefined : props.popover.id}
                          style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', background: 'none', border: 'none', cursor: 'pointer', padding: 0, width: '100%', textAlign: 'left' }}
                        >
                          <div style={labelStyle}>
                            <FontAwesomeIcon icon={bookingSearchbarWithBedrooms ? farBed : farUserFriends} style={{ color: iconColor }} />
                            {bookingSearchbarWithBedrooms ? t('search.bedrooms') : t('search.guests')}
                          </div>
                          <div style={{ ...valueStyle, fontSize: props.showOnMobile ? '14px' : '22px', lineHeight: props.showOnMobile ? 'normal' : valueStyle.lineHeight, opacity: (bookingSearchbarWithBedrooms ? localBedrooms > 0 : (localAdultsNum > 0 || localKidsNum > 0 || localInfantsNum > 0)) ? 1 : 0.5 }}>
                            {bookingSearchbarWithBedrooms
                              ? (localBedrooms > 0 ? t.plural('search.bedroomCount', localBedrooms) : t('search.bedrooms'))
                              : (() => {
                                const parts = [];
                                if (localAdultsNum > 0) parts.push(t.plural('search.adultCount', localAdultsNum));
                                if (localKidsNum > 0) parts.push(t.plural('search.kidCount', localKidsNum));
                                if (localInfantsNum > 0) parts.push(t.plural('search.infantCount', localInfantsNum));
                                return parts.length > 0 ? parts.join(', ') : t('search.whoWillStay');
                              })()}
                          </div>
                        </button>
                        {!props.showOnMobile && props.hasOwnProperty('popover') && (
                          <ThemeProvider theme={props.popover.customTheme}>
                            <Popover
                              disableScrollLock
                              id={props.popover.id}
                              open={props.popover.open}
                              anchorEl={props.popover.anchorEl}
                              onClose={props.popover.handleClose}
                              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                              PaperProps={{ style: { marginTop: '-2px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: '4px' } }}
                            >
                              <div style={{ padding: '16px 20px 8px' }}>
                                <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#000', opacity: 0.6, display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <FontAwesomeIcon icon={bookingSearchbarWithBedrooms ? farBed : farUserFriends} />
                                  {bookingSearchbarWithBedrooms ? t('search.bedrooms') : t('search.whoWillStay')}
                                </div>
                              </div>
                              <Guests
                                popover={props.popover}
                                dialog={props.dialog}
                                mobile={false}
                                dispatchValues={false}
                                adultsNum={localAdultsNum}
                                kidsNum={localKidsNum}
                                infantsNum={localInfantsNum}
                                setAdultsNum={setLocalAdultsNum}
                                setKidsNum={setLocalKidsNum}
                                setInfantsNum={setLocalInfantsNum}
                                bedroomsNum={localBedrooms ?? 0}
                                setBedroomsNum={setLocalBedrooms}
                              />
                            </Popover>
                          </ThemeProvider>
                        )}
                      </div>
                    ): <></>}

                    {/* Find Hotels button — desktop only */}
                    {!props.showOnMobile && (
                      <div className="col-12 col-md-4 d-flex align-items-center ps-4" >
                        <FindButton />
                      </div>
                    )}
                  </div>
                </LocalizationProvider>
              </ThemeProvider>

              {/* Secondary row — "book safely" note (non-PM) + Rooms selector for hotels */}
              {(() => {
                const showRooms = !props.showOnMobile && showHotelBedrooms && (localDateRange[0] != null || localAdultsNum > 0 || localKidsNum > 0 || localInfantsNum > 0);
                if (isCssStuck || isBarSticky  || (!showManagerSafeNote && !showRooms)) return <></>;
                return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', minHeight: '44px', borderTop: `1px solid ${dividerColor}20`, overflow: 'hidden', padding: props.showOnMobile ? '8px 1.5rem 8px 2.5rem' : '4px 3rem' }}>
                  {managerSafeNote || <></>}
                  {isHotel ? (
                  <div className="col-auto" style={{ display: 'flex', alignItems: 'stretch', position: 'relative', flex: '0 0 auto' }}>
                    <button
                      type="button"
                      onClick={(e) => setBedroomsAnchorEl(e.currentTarget)}
                      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer', padding: '10px 20px 10px 0', textAlign: 'left', width: '100%' }}
                    >
                      <div style={{ fontSize: '14px', fontWeight: 500, color: inputColor, whiteSpace: 'nowrap', lineHeight: 1.2, display: 'flex', gap: '6px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ opacity: (localBedrooms ?? 0) > 0 ? 1 : 0.5 }}>
                          {(localBedrooms ?? 0) > 0 ? t.plural('search.roomCount', localBedrooms) : t('search.rooms')}
                        </span>
                        <svg width="10" viewBox="0 0 10 10" fill="none">
                          <path d="M2 3.5L5 6.5L8 3.5" stroke={inputColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    </button>
                    <ThemeProvider theme={props.popover?.customTheme || {}}>
                      <Popover
                        disableScrollLock
                        open={Boolean(bedroomsAnchorEl)}
                        anchorEl={bedroomsAnchorEl}
                        onClose={() => setBedroomsAnchorEl(null)}
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{ style: { marginTop: '-2px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: '4px' } }}
                      >
                        <div style={{ padding: '16px 20px 8px' }}>
                          <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#000', opacity: 0.6, display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FontAwesomeIcon icon={farBed} />
                            {t('search.rooms')}
                          </div>
                        </div>
                        <Guests
                          popover={{ guestsSetText: () => undefined, handleClose: () => setBedroomsAnchorEl(null), kids: { amount: 0 }, infants: { amount: 0 } }}
                          dialog={props.dialog}
                          mobile={false}
                          dispatchValues={false}
                          forceBedrooms={true}
                          bedroomsNum={localBedrooms ?? 0}
                          setBedroomsNum={setLocalBedrooms}
                        />
                      </Popover>
                    </ThemeProvider>
                  </div>
                  ) : <></>}
                </div>
                );
              })()}

              {/* Secondary row — Guests only (multi-property sites, once a destination is picked) */}
              {props.isManager && props.hasOwnProperty('popover') && (isSearchPage || selectedLocation !== null) && !isCssStuck && !(isBarSticky) ? (
                <div className={`${isSearchPage ? 'pe-4' : 'px-4'}`} style={{ display: 'flex', alignItems: 'center', height: '44px', borderTop: `1px solid ${dividerColor}20`, overflow: 'hidden' }}>
                  {/* <div style={{ borderTop: `1px solid ${dividerColor}`, margin: '0 20px' }} /> */}

                  <div className="col-auto" style={{ display: 'flex', alignItems: 'stretch', position: 'relative' }}>
                    {/* <div style={labelStyleSecondRow} /> */}
                    <button
                      type="button"
                      id="guests_label"
                      onClick={props.popover.handleOpen}
                      aria-describedby={props.popover.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '6px',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '10px 20px 10px 0',
                        textAlign: 'left',
                        width: '100%',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '14px',
                          fontWeight: 500,
                          color: inputColor,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          lineHeight: 1.2,
                          display: 'flex',
                          gap: '6px',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        {bookingSearchbarWithBedrooms ? (
                          <span style={{ opacity: localBedrooms > 0 ? 1 : 0.5 }}>
                            {localBedrooms > 0 ? t.plural('search.bedroomCount', localBedrooms) : t('search.bedrooms')}
                          </span>
                        ) : (() => {
                          const parts = [];
                          if (localAdultsNum > 0) parts.push(t.plural('search.adultCount', localAdultsNum));
                          if (localKidsNum > 0) parts.push(t.plural('search.kidCount', localKidsNum));
                          if (localInfantsNum > 0) parts.push(t.plural('search.infantCount', localInfantsNum));
                          const hasGuests = parts.length > 0;
                          return <span style={{ opacity: hasGuests ? 1 : 0.5 }}>
                            <FontAwesomeIcon icon={bookingSearchbarWithBedrooms ? farBed : farUserFriends} style={{ paddingRight: 4 }} />{hasGuests ? parts.join(', ') : t('search.guests')}</span>;
                        })()}
                        <svg width="10" viewBox="0 0 10 10" fill="none">
                          <path d="M2 3.5L5 6.5L8 3.5" stroke={inputColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    </button>
                    <ThemeProvider theme={props.popover.customTheme}>
                      <Popover
                        disableScrollLock
                        id={props.popover.id}
                        open={props.popover.open}
                        anchorEl={props.popover.anchorEl}
                        onClose={props.popover.handleClose}
                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{ style: { marginTop: '-2px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: '4px' } }}
                      >
                        <div style={{ padding: '16px 20px 8px' }}>
                          <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#000', opacity: 0.6, display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FontAwesomeIcon icon={bookingSearchbarWithBedrooms ? farBed : farUserFriends} />
                            {bookingSearchbarWithBedrooms ? t('search.bedrooms') : t('search.whoWillStay')}
                          </div>
                        </div>
                        <Guests
                          popover={props.popover}
                          dialog={props.dialog}
                          mobile={false}
                          dispatchValues={false}
                          adultsNum={localAdultsNum}
                          kidsNum={localKidsNum}
                          infantsNum={localInfantsNum}
                          setAdultsNum={setLocalAdultsNum}
                          setKidsNum={setLocalKidsNum}
                          setInfantsNum={setLocalInfantsNum}
                          bedroomsNum={localBedrooms ?? 0}
                          setBedroomsNum={setLocalBedrooms}
                        />
                      </Popover>
                    </ThemeProvider>
                  </div>

                  {/* Property type — inline if ≤ 3, popover if > 3 */}
                  {propertyTypes.length > 1 && (
                    propertyTypes.length <= 3 ? (
                      <div className="col-auto" style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '10px 20px' }}>
                        {propertyTypes.map((pt: { id: number, type: string }) => (
                          <label key={pt.id} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: 500, color: inputColor, whiteSpace: 'nowrap' }}>
                            <input
                              type="checkbox"
                              checked={selectedPropertyTypes.includes(pt.id)}
                              onChange={(e) => {
                                setSelectedPropertyTypes(prev =>
                                  e.target.checked ? [...prev, pt.id] : prev.filter(id => id !== pt.id)
                                );
                              }}
                              style={{ width: '14px', height: '14px', cursor: 'pointer', accentColor: labelColor }}
                            />
                            {pt.type}
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="col-auto" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <button
                          type="button"
                          onClick={(e) => setPtAnchorEl(e.currentTarget)}
                          style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer', padding: '10px 20px', textAlign: 'left' }}
                        >
                          <div style={{ fontSize: '14px', fontWeight: 500, color: inputColor, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ opacity: selectedPropertyTypes.length > 0 ? 1 : 0.5 }}>
                              {selectedPropertyTypes.length > 0
                                ? propertyTypes.filter((pt: { id: number, type: string }) => selectedPropertyTypes.includes(pt.id)).map((pt: { id: number, type: string }) => pt.type).join(', ')
                                : t('search.addPropertyType')}
                            </span>
                            {selectedPropertyTypes.length > 0 && (
                              <span onClick={(e) => { e.stopPropagation(); setSelectedPropertyTypes([]); }} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <FontAwesomeIcon icon={faCircleXmark} style={{ color: inputColor, fontSize: '14px' }} />
                              </span>
                            )}
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                              <path d="M2 3.5L5 6.5L8 3.5" stroke={inputColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                        </button>
                        <Popover
                          disableScrollLock
                          open={Boolean(ptAnchorEl)}
                          anchorEl={ptAnchorEl}
                          onClose={() => setPtAnchorEl(null)}
                          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                          PaperProps={{ style: { marginTop: '4px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: '4px', minWidth: '200px' } }}
                        >
                          <div style={{ padding: '16px 20px 8px' }}>
                            <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: '#000', opacity: 0.6, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <FontAwesomeIcon icon={faBuildings} />
                              {t('search.propertyType')}
                            </div>
                            {propertyTypes.map((pt: { id: number, type: string }) => (
                              <label key={pt.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', cursor: 'pointer', fontSize: '14px', color: '#1a1a1a', borderBottom: '1px solid #f0f0f0' }}>
                                <input
                                  type="checkbox"
                                  checked={selectedPropertyTypes.includes(pt.id)}
                                  onChange={(e) => {
                                    setSelectedPropertyTypes(prev =>
                                      e.target.checked ? [...prev, pt.id] : prev.filter(id => id !== pt.id)
                                    );
                                  }}
                                  style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: btnBgColor || designColor || '#000' }}
                                />
                                {pt.type}
                              </label>
                            ))}
                            <div style={{ padding: '8px 0' }} />
                          </div>
                        </Popover>
                      </div>
                    )
                  )}
                </div>
              ): <></>}
            </div>
          </div>
        </div>

        {/* Mobile bottom drawer — calendar + guests */}
        {props.showOnMobile ? (
          <SwipeableDrawer
            anchor="bottom"
            open={mobileDrawerOpen}
            onClose={() => { setMobileDrawerOpen(false); if (mobileFromSummary.current) { mobileFromSummary.current = false; setMobileSummaryOpen(true); } }}
            onOpen={() => setMobileDrawerOpen(true)}
            disableSwipeToOpen
            disableDiscovery
            disableBackdropTransition
            ModalProps={{ keepMounted: true }}
            sx={{
              zIndex: 1300,
              '& .MuiDrawer-paper': {
                height: mobileDrawerTab === 'destination' ? '85vh' : 'auto',
                maxHeight: '85vh',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <div style={{ width: 30, height: 6, backgroundColor: '#ccc', borderRadius: 3, margin: '12px auto 0' }} />
            <div style={{ display: 'flex', marginTop: 12, flexDirection: 'column', flex: 1 }}>
              <div className="row align-center" style={{ margin: 0 }}>
                {mobileDrawerTab === 'destination' ? (
                  <>
                    {props.isManager && (
                      <div className="col-12" style={{ padding: '0 16px 12px' }}>
                        <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b6b6b', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: 5 }}>
                          <FontAwesomeIcon icon={farMapMarkerAlt} />
                          {Checkers.isValidString(searchSelectLabel) ? searchSelectLabel : t('search.locationPropertySpaced')}
                        </div>

                        {/* <AsyncSelect
                              noOptionsMessage={() => 'nothing found'}
                              loadingMessage={() => 'searching...'}
                              cacheOptions={false}
                              defaultOptions={defaultOptionsHandler( values )}
                              loadOptions={loadSearchOptions}
                              onChange={handleInputChange}
                              className="SearchBar-Form__form-group-select"
                              isSearchable
                              value={selectedValues}
                              placeholder={t('search.selectA', { title: props.title })}
                              blurInputOnSelect
                              menuPlacement={'bottom'}
                              isMulti={true}
                              components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                            /> */}
                        <AsyncSelect
                          cacheOptions={false}
                          defaultOptions={defaults}
                          loadOptions={loadOptions}
                          onChange={(input) => {
                            handleInputChange(input);
                            mobileFromSummary.current = false;
                            setMobileDrawerOpen(false);
                            setMobileSummaryOpen(true);
                          }}
                          value={selectedLocation}
                          id="location_property_mobile"
                          name="location_property_mobile"
                          inputId="location_property_mobile"
                          instanceId="location_property_mobile"
                          isSearchable
                          placeholder={t('search.whereNext')}
                          menuPlacement="bottom"
                          blurInputOnSelect
                          // formatCreateLabel={(v: string) => 'Search for ' + v}
                          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                        // styles={asyncSelectStyles}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="col-12 d-flex justify-content-center p-b-0 p-t-10">
                    <div className="row w-100 no-padding no-margin" style={{ maxWidth: 350 }}>
                      <ThemeProvider theme={props.calendar?.customTheme || {}}>
                        <DateRangeWrapper
                          forList={true}
                          theme={props.calendar?.customTheme}
                          isStatic={1}
                          toggleDrawer={setMobileDrawerOpen}
                          containerClass="p-0 border-bottom"
                        />
                      </ThemeProvider>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div style={{ position: 'sticky', bottom: 0, background: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #eee' }}>
              {mobileDrawerTab === 'dates' ? (
                <Button onClick={() => { dispatch(setDateRange([null, null])); setLocalDateRange([null, null]); }} className="text-capitalize" style={{ color: 'black', textDecoration: 'underline' }}>{t('common.clear')}</Button>
              ) : <span />}
              <Button variant="outlined" className="text-black border border-secondary" onClick={() => {
                mobileFromSummary.current = false;
                setMobileDrawerOpen(false);
                if (mobileDrawerTab === 'destination' && !localDateRange[0]) {
                  setMobileDrawerTab('dates');
                  setMobileDrawerOpen(true);
                } else {
                  setMobileSummaryOpen(true);
                }
              }}>{t('common.done')}</Button>
            </div>
          </SwipeableDrawer>
        ) : <></>}

        {/* Mobile Summary Drawer — guests + property type + search */}
        {props.showOnMobile ? (
          <SwipeableDrawer
            anchor="bottom"
            open={mobileSummaryOpen}
            onClose={() => setMobileSummaryOpen(false)}
            onOpen={() => setMobileSummaryOpen(true)}
            disableSwipeToOpen

            ModalProps={{ keepMounted: false }}
            sx={{
              zIndex: 1300,
              '& .MuiDrawer-paper': {
                height: 'auto',
                maxHeight: '85vh',
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <div style={{ width: 30, height: 6, backgroundColor: '#ccc', borderRadius: 3, margin: '12px auto 0' }} />
            {/* Summary header */}
            <div style={{ padding: '12px 16px 0', borderBottom: '1px solid #eee' }}>
              {props.isManager ? (
                <div
                  onClick={() => { mobileFromSummary.current = true; setMobileSummaryOpen(false); setMobileDrawerTab('destination'); setMobileDrawerOpen(true); }}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                >
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <FontAwesomeIcon icon={farMapMarkerAlt} /> {Checkers.isValidString(searchSelectLabel) ? searchSelectLabel : t('search.locationProperty')}
                    </div>
                    <div style={{ fontSize: 14, color: selectedLocation ? '#1a1a1a' : '#aaa' }}>
                      {selectedLocation ? selectedLocation.label : t('search.notSelected')}
                    </div>
                  </div>
                  <span style={{ color: '#aaa' }}>›</span>
                </div>
              ): <></>}
              <div
                onClick={() => { mobileFromSummary.current = true; setMobileSummaryOpen(false); setMobileDrawerTab('dates'); setMobileDrawerOpen(true); }}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', cursor: 'pointer' }}
              >
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <FontAwesomeIcon icon={farCalendar} /> {nightCount ? t.plural('search.nights', nightCount) : t('search.dates')}
                  </div>
                  <div style={{ fontSize: 14, color: dateRangeLabel ? '#1a1a1a' : '#aaa' }}>
                    {dateRangeLabel || t('search.notSelected')}
                  </div>
                </div>
                <span style={{ color: '#aaa' }}>›</span>
              </div>
            </div>
            <div style={{ padding: '0 16px' }}>
              {/* Guests row (or Bedrooms, when the site is set to search by bedrooms) */}
              <div
                onClick={() => setMobileSubDrawer('guests')}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
              >
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <FontAwesomeIcon icon={bookingSearchbarWithBedrooms ? farBed : farUserFriends} /> {bookingSearchbarWithBedrooms ? t('search.bedrooms') : t('search.guests')}
                  </div>
                  <div style={{ fontSize: 14, color: (bookingSearchbarWithBedrooms ? (localBedrooms ?? 0) > 0 : (localAdultsNum > 0 || localKidsNum > 0 || localInfantsNum > 0)) ? '#1a1a1a' : '#aaa' }}>
                    {bookingSearchbarWithBedrooms
                      ? ((localBedrooms ?? 0) > 0 ? t.plural('search.bedroomCount', localBedrooms) : t('search.notSelected'))
                      : (() => {
                        const parts = [];
                        if (localAdultsNum > 0) parts.push(t.plural('search.adultCount', localAdultsNum));
                        if (localKidsNum > 0) parts.push(t.plural('search.kidCount', localKidsNum));
                        if (localInfantsNum > 0) parts.push(t.plural('search.infantCount', localInfantsNum));
                        return parts.length > 0 ? parts.join(', ') : t('search.notSelected');
                      })()}
                  </div>
                </div>
                <span style={{ color: '#aaa' }}>›</span>
              </div>
              {showHotelBedrooms ? (
                <div
                  onClick={() => setMobileSubDrawer('bedrooms')}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                >
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <FontAwesomeIcon icon={farBed} /> {t('search.rooms')}
                    </div>
                    <div style={{ fontSize: 14, color: (localBedrooms ?? 0) > 0 ? '#1a1a1a' : '#aaa' }}>
                      {(localBedrooms ?? 0) > 0 ? t.plural('search.roomCount', localBedrooms) : t('search.notSelected')}
                    </div>
                  </div>
                  <span style={{ color: '#aaa' }}>›</span>
                </div>
              ): <></>}
              {propertyTypes.length > 1 && (
                <div
                  onClick={() => setMobileSubDrawer('propertyType')}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f0f0f0', cursor: 'pointer' }}
                >
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <FontAwesomeIcon icon={faBuildings} /> {t('search.propertyType')}
                    </div>
                    <div style={{ fontSize: 14, color: selectedPropertyTypes.length > 0 ? '#1a1a1a' : '#aaa' }}>
                      {selectedPropertyTypes.length > 0
                        ? propertyTypes.filter((pt: { id: number, type: string }) => selectedPropertyTypes.includes(pt.id)).map((pt: { id: number, type: string }) => pt.type).join(', ')
                        : t('search.notSelected')}
                    </div>
                  </div>
                  <span style={{ color: '#aaa' }}>›</span>
                </div>
              )}
            </div>

            <div style={{ position: 'sticky', bottom: 0, background: '#fff', padding: '12px 16px', borderTop: '1px solid #eee' }}>
              <button
                type="button"
                onClick={() => { 
                  (document.getElementById('frm_book') as HTMLFormElement | null)?.requestSubmit()
                  setMobileSummaryOpen(false)
                }}
                style={{ width: '100%', padding: '14px', borderRadius: 8, border: 'none', background: designColor || '#222', color: designMode ? 'white' : '#000', fontSize: 16, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
              >
                <FontAwesomeIcon icon={faSearch} /> {props.showOnMobile ? t('search.updateSearch') : Checkers.isValidString(searchBtnLabel) ? searchBtnLabel : t('search.search')}
              </button>
            </div>
          </SwipeableDrawer>
        ) : <></>}

        {/* Sub-drawer: Guests */}
        {props.showOnMobile ? (
          <SwipeableDrawer anchor="bottom" open={mobileSubDrawer === 'guests'} onClose={() => setMobileSubDrawer(null)} onOpen={undefined} disableSwipeToOpen ModalProps={{ keepMounted: false }}
            sx={{ zIndex: 1400, '& .MuiDrawer-paper': { height: 'auto', maxHeight: '85vh', borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: 'auto' } }}
          >
            <div style={{ width: 30, height: 6, backgroundColor: '#ccc', borderRadius: 3, margin: '12px auto 0' }} />
            <div style={{ padding: '12px 16px 0' }}>
              <Guests
                popover={{ guestsSetText: setMobileGuestsText, guestsText: mobileGuestsText, kids: { amount: 0 }, infants: { amount: 0 } }}
                dialog={{ open: mobileDialogOpen, handleOpen: () => setMobileDialogOpen(true), handleClose: () => setMobileDialogOpen(false), setOpen: setMobileDialogOpen }}
                mobile={false} dispatchValues={true} labelWeight=""
              />
            </div>
            <div style={{ position: 'sticky', bottom: 0, background: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #eee' }}>
              <Button onClick={() => { dispatch(setAdults(0)); dispatch(setKids(0)); dispatch(setInfants(0)); setLocalAdultsNum(0); setLocalKidsNum(0); setLocalInfantsNum(0); }} className="text-capitalize" style={{ color: 'black', textDecoration: 'underline' }}>{t('common.clear')}</Button>
              <Button variant="outlined" className="text-black border border-secondary" onClick={() => { setMobileSubDrawer(null); setMobileSummaryOpen(true); }}>{t('common.done')}</Button>
            </div>
          </SwipeableDrawer>
        ) : <></>}

        {/* Sub-drawer: Bedrooms (hotels) */}
        {props.showOnMobile && showHotelBedrooms ? (
          <SwipeableDrawer anchor="bottom" open={mobileSubDrawer === 'bedrooms'} onClose={() => { setMobileSubDrawer(null); setMobileSummaryOpen(true); }} onOpen={undefined} disableSwipeToOpen ModalProps={{ keepMounted: false }}
            sx={{ zIndex: 1400, '& .MuiDrawer-paper': { height: 'auto', maxHeight: '85vh', borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: 'auto' } }}
          >
            <div style={{ width: 30, height: 6, backgroundColor: '#ccc', borderRadius: 3, margin: '12px auto 0' }} />
            <div style={{ padding: '16px 16px 0' }}>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 4 }}>
                <FontAwesomeIcon icon={farBed} /> {t('search.rooms')}
              </div>
              <Guests
                popover={{ guestsSetText: () => undefined, handleClose: () => { setMobileSubDrawer(null); setMobileSummaryOpen(true); }, kids: { amount: 0 }, infants: { amount: 0 } }}
                dialog={{ open: mobileDialogOpen, handleOpen: () => setMobileDialogOpen(true), handleClose: () => setMobileDialogOpen(false), setOpen: setMobileDialogOpen }}
                mobile={false} dispatchValues={false} labelWeight=""
                forceBedrooms={true}
                bedroomsNum={localBedrooms ?? 0}
                setBedroomsNum={setLocalBedrooms}
              />
            </div>
            <div style={{ position: 'sticky', bottom: 0, background: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #eee' }}>
              <Button onClick={() => setLocalBedrooms(0)} className="text-capitalize" style={{ color: 'black', textDecoration: 'underline' }}>{t('common.clear')}</Button>
              <Button variant="outlined" className="text-black border border-secondary" onClick={() => { setMobileSubDrawer(null); setMobileSummaryOpen(true); }}>{t('common.done')}</Button>
            </div>
          </SwipeableDrawer>
        ) : <></>}

        {/* Sub-drawer: Property Type */}
        <div style={{ padding: '0 16px' }}>
          {props.showOnMobile && propertyTypes.length > 1 ? (
            <SwipeableDrawer anchor="bottom" open={mobileSubDrawer === 'propertyType'} onClose={() => { setMobileSubDrawer(null); setMobileSummaryOpen(true); }} onOpen={undefined} disableSwipeToOpen ModalProps={{ keepMounted: false }}
              sx={{ zIndex: 1400, '& .MuiDrawer-paper': { height: '85vh', maxHeight: '85vh', borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: 'auto', display: 'flex', flexDirection: 'column' } }}
            >
              <div style={{ width: 30, height: 6, backgroundColor: '#ccc', borderRadius: 3, margin: '12px auto 0' }} />
              <div style={{ padding: '16px', flex: 1 }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#888', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 4 }}>
                  <FontAwesomeIcon icon={faBuildings} /> {t('search.propertyType')}
                </div>
                <Select
                  isMulti
                  options={propertyTypes.map((pt: { id: number, type: string }) => ({ value: pt.id, label: pt.type }))}
                  value={propertyTypes.filter((pt: { id: number, type: string }) => selectedPropertyTypes.includes(pt.id)).map((pt: { id: number, type: string }) => ({ value: pt.id, label: pt.type }))}
                  onChange={(selected) => setSelectedPropertyTypes((selected || []).map((s: { value: number }) => s.value))}
                  placeholder={t('search.allPropertyTypes')} menuPlacement="bottom" isClearable
                  styles={{
                    control: (b) => ({ ...b, border: '1px solid #ddd', borderRadius: 8, boxShadow: 'none', minHeight: 44 }),
                    valueContainer: (b) => ({ ...b, padding: '2px 12px' }),
                    placeholder: (b) => ({ ...b, color: '#aaa', fontSize: 15 }),
                    menu: (b) => ({ ...b, zIndex: 9999 }),
                  }}
                />
              </div>
              <div style={{ position: 'sticky', bottom: 0, background: '#fff', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #eee' }}>
                <span />
                <Button variant="outlined" className="text-black border border-secondary" onClick={() => setMobileSubDrawer(null)}>{t('common.done')}</Button>
              </div>
            </SwipeableDrawer>
          ) : <></>}
        </div>
      </form>
    </div>
  );

  return (
    <>
      {/* sentinel: stays in flow at bar's natural top position */}
      <div ref={sentinelRef} style={{ height: 0, pointerEvents: 'none' }} />
      {isBarSticky && <div style={{ height: barHeight }} />}
      {isBarSticky && portalRef.current
        ? ReactDOM.createPortal(barDiv, portalRef.current)
        : barDiv
      }
    </>
  );
}
